<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-17 19:22:59
 * @FilePath: 
 * @Description: 幸运大转盘
-->
<template>
  <div class="lucky_draw_con">
    <div
      class="my-flex-column phone_page_con bg_cover_con"
      :style="{ backgroundImage: 'url(' + photoData['big'] + ')' }"
    >
      <div class="wheel_blue_con">
        <div class="wheel_bg_con">
          <div class="wheel-bg" :style="rotateStyle">
            <img class="full_img" :src="photoData['wheel']" alt="" />
            <div class="prize-list">
              <div
                class="prize-item"
                v-for="(item, index) in prizeList"
                :key="index"
                :style="item.style"
              >
                <!-- <div class="prize-pic">
                <img :src="item.icon" />
              </div> -->
                <div class="prize-type">{{ item.GoodsName }}</div>
              </div>
            </div>
          </div>

          <div class="start_draw_btn" @click="beginRotate">
            <img class="full_img" :src="photoData['start']" alt="" />
          </div>
        </div>
        <div class="lucky_draw_times">今日还剩{{ drawCount }}次抽奖机会</div>
        <div class="draw_btn_con">
          <div
            class="btn_item m-r-20 bg_cover_con"
            :style="{ backgroundImage: 'url(' + photoData['ruleBtn'] + ')' }"
            @click="handleShowRule"
          ></div>

          <div
            class="btn_item bg_cover_con"
            :style="{ backgroundImage: 'url(' + photoData['giftBtn'] + ')' }"
            @click="handleShowGift"
          ></div>
        </div>
      </div>
    </div>
    <van-popup class="gift_popup_con" v-model="showRuleModal" position="center">
      <div class="overlay_con rule_overlay_con">
        <div class="rule_info_con">
          <img class="full_img" :src="photoData['ruleBg']" alt="" />
          <div class="rule_induction_con">
            <div class="bold c-font-30 c-m-b-30 c-t-c">活动规则</div>
            <div>
              <div
                class="ql-container ql-snow"
                v-if="textInduction && textInduction.length > 0"
              >
                <div class="ql-editor" v-html="textInduction" />
              </div>
              <van-empty image-size="80" v-else description="暂无规则信息" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="close_btn_con btn_item bg_cover_con"
        :style="{
          backgroundImage: 'url(' + photoData['ruleSubmitBtn'] + ')',
        }"
        @click="handleHideModal"
      ></div>
    </van-popup>
    <van-popup class="gift_popup_con" v-model="showGiftModal" position="center">
      <div class="overlay_con gift_overlay_con">
        <div class="gift_info_con">
          <img class="full_img" :src="photoData['giftBg']" alt="" />
          <div class="gift_list_con">
            <div class="bold c-font-30 c-m-b-30 c-t-c">中奖记录</div>
            <template v-if="allGiftLogList.length > 0">
              <div class="f m-t-30 m-b-10 ft-36 gift_item_title">
                <p class="f-1">所中奖品</p>
                <p class="f-1">奖品数量</p>
                <p class="f-1">奖品类型</p>
              </div>
              <div>
                <div class="gift_all_list">
                  <div
                    class="f m-tb-30 c-font-26"
                    v-for="(item, index) in allGiftLogList"
                    :key="index"
                  >
                    <p class="f-1">{{ item.ProductName }}</p>
                    <p class="f-1">{{ item.Quantity }}</p>
                    <p class="f-1 f">
                      <span class="w-100">
                        {{ item.ProductType }}
                      </span>

                      <span
                        @click="handleShowUseCode(item)"
                        class="gift_btn"
                        v-if="item.ProductType !== '积分'"
                      >
                        {{ item.Status.Id == 0 ? "查看" : item.Status.Name }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <van-empty
              v-if="allGiftLogList.length === 0"
              image-size="80"
              description="暂无中奖数据"
            />
          </div>
        </div>
      </div>
      <div
        class="close_btn_con btn_item bg_cover_con"
        :style="{
          backgroundImage: 'url(' + photoData['giftSubmitBtn'] + ')',
          bottom: '7%',
        }"
        @click="handleHideModal"
      ></div>
    </van-popup>
    <van-overlay :show="showResultModal" z-index="5">
      <div class="overlay_con result_overlay_con">
        <div class="result_info_con">
          <img
            class="full_img"
            :src="photoData[getPrize.GoodsType != 5 ? 'resultBg' : 'noGiftBg']"
            alt=""
          />
          <div class="result_induction_con">
            <div class="bold c-font-30 c-m-b-30">
              {{ getPrize.GoodsType != 5 ? "中奖了" : "谢谢参与" }}
            </div>
            <div>
              {{
                getPrize.GoodsType != 5
                  ? "恭喜您，抽中“" + getPrize.GoodsName + "”！"
                  : "与奖品擦肩而过，下次努力哦！"
              }}
            </div>
          </div>
        </div>
        <div
          class="close_btn_con btn_item bg_cover_con"
          :style="{
            backgroundImage: 'url(' + photoData['resultSubmitBtn'] + ')',
          }"
          @click="handleHideModal"
        ></div>
      </div>
    </van-overlay>
    <van-dialog
      title="商品兑换码"
      v-model="showQr"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="handleHideCodeModal"
    >
      <div class="p-26 c-fc-center code_con">
        <div
          class="code-box"
          v-for="(subItem, subIndex) in qrCodeList"
          :key="subIndex"
        >
          <vue-qr :text="subItem.toString()" class="qr_code"></vue-qr>
        </div>
        <p>兑换时向收银员出示此码兑换后失效</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import wxConfig from "@/utils/wxConfig.js";

import {
  getDrawActivityInfo,
  getDrawGiftList,
  getDrawTimesByPoint,
  getDrawTimesByShare,
  getDrawGiftLogList,
  submitDraw,
} from "@/api/draw";
import { getUserCardInfo } from "@/api/member";
import { Dialog } from "vant";

const CIRCLE_ANGLE = 360;
export default {
  name: "LuckyTurntable",
  props: {},
  data() {
    return {
      isMember: false,
      myPointData: 0, //我的积分数
      photoData: {
        big: "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/drawBg.png",
        wheel:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/wheelBg.png",
        start:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/startBg.png",
        resultBg:
          // "http://vip.wechat.goldenyun.cn/wx.front.image/cdn/miniapp/images/luckDraw_pop.png",
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/gift_bg.png",
        noGiftBg:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/nogift_bg.png",
        resultSubmitBtn:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/signbutton.png",
        ruleBtn:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/ruleBtn.png",
        ruleSubmitBtn:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/signbutton.png",
        giftBtn:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/giftBtn.png",
        giftSubmitBtn:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/signbutton.png",
        giftBg:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/gift_list_bg.png",
        ruleBg:
          "https://saas-ticket.oss-cn-beijing.aliyuncs.com/common/rule_bg.png",
      },
      prizeList: [],
      prePrizeList: [],
      config: {
        // 总旋转时间
        duration: 4000,
        // 旋转圈数
        circle: 8,
        mode: "ease-in-out",
      },
      drawCount: 0, // 剩余抽奖次数
      shareDrawCount: null,
      pointDrawCount: null,
      duration: 3000, // 转盘旋转时间
      angleList: [],
      isRotating: false,
      rotateAngle: 0, // 旋转角度
      index: 0,
      getPrize: { GoodsName: "" },
      allGiftLogList: [],
      showRuleModal: false,
      textInduction: "",
      showGiftModal: false,
      showResultModal: false,
      showQr: false,
      qrCodeList: [],
    };
  },
  components: {},
  computed: {
    rotateStyle() {
      return `
        -webkit-transition: transform ${this.config.duration}ms ${this.config.mode};
        transition: transform ${this.config.duration}ms ${this.config.mode};
        -webkit-transform: rotate(${this.rotateAngle}deg);
            transform: rotate(${this.rotateAngle}deg);`;
    },
  },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.handleInitMemberInfo();
      this.handleGetActivityInfo();
    },
  },
  created() {},

  mounted() {
    this.activityId = this.$route.query.id;
    if (!this.activityId) {
      this.$toast("缺少必要参数，请检查页面地址", "middle");
      return;
    }
    this.vpnId = this.$store.state.vpnId;
    if (this.vpnId) {
      this.handleInitMemberInfo();
      this.handleGetActivityInfo();
    }
  },
  methods: {
    handleInitMemberInfo() {
      getUserCardInfo({ vpnId: this.vpnId }).then((res) => {
        if (res.Code) {
          this.isMember = false;
          return;
        }
        if (res.Token) {
          setToken(res.Token);
        }

        this.isMember = true;
        this.myPointData = res.Integral;
        this.MemberAccountId = res.MemberAccountId;
      });
    },
    handleGetActivityInfo() {
      getDrawActivityInfo({ id: this.activityId }).then((res) => {
        this.handleGetGiftList();

        this.textInduction = res.RuleText;
        this.drawCount = res.LeaveLotteryDrawCount;
        this.shareDrawCount = res.LeaveShareCount; //当日剩余分享获取抽奖机会次数 null则不限制
        this.pointDrawCount = res.LeaveIntegralExChangeCount; //当日剩余积分兑换抽奖机会次数 null则不限制
        this.drawTimeInfo = res.LotteryDrawChanceDTO;
        this.isNeedMember = res.MustWeMember;
        const imgClaims = res.Claims;
        if (imgClaims && imgClaims.length > 0) {
          this.handleInitImgData(imgClaims.filter((item) => item.TypeId != 3));
        }
        this.isEnableShare = res.EnableShare;
        if (res.EnableShare) {
          // 活动分享图
          let shareImgUrl = "";
          if (res.Claims.length > 0) {
            const imgItem = res.Claims.find((element) => element.TypeId == 3);
            if (imgItem) {
              shareImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
            }
          }
          var _this = this;
          //   // 分享图
          wxConfig.WeChatShare(
            _this,
            location.href,
            res.ShareTitle,
            shareImgUrl,
            res.ShareText,
            _this.getShareDrawTimes
          );
        }
      });
    },
    handleInitImgData(imgArr) {
      if (imgArr && imgArr.length > 0) {
        imgArr.forEach((item) => {
          if (item.TypeId == 4) {
            this.photoData.big = item.Value;
          }
          if (item.TypeId == 5) {
            this.photoData.wheel = item.Value;
          }
          if (item.TypeId == 6) {
            this.photoData.start = item.Value;
          }
          if (item.TypeId == 7) {
            this.photoData.resultBg = item.Value;
          }
          if (item.TypeId == 8) {
            this.photoData.noGiftBg = item.Value;
          }
          if (item.TypeId == 9) {
            this.photoData.resultSubmitBtn = item.Value;
          }
          if (item.TypeId == 10) {
            this.photoData.ruleBtn = item.Value;
          }
          if (item.TypeId == 11) {
            this.photoData.ruleSubmitBtn = item.Value;
          }
          if (item.TypeId == 12) {
            this.photoData.giftBtn = item.Value;
          }
          if (item.TypeId == 13) {
            this.photoData.giftSubmitBtn = item.Value;
          }
          if (item.TypeId == 14) {
            this.photoData.giftBg = item.Value;
          }
          if (item.TypeId == 15) {
            this.photoData.ruleBg = item.Value;
          }
        });
      }
    },
    handleGetGiftList() {
      getDrawGiftList({ eventId: this.activityId, VpnId: this.vpnId }).then(
        (res) => {
          this.prePrizeList = res;
          this.prizeList = this.formatPrizeList(this.prePrizeList);
        }
      );
    },
    handleGetGiftLogList() {
      getDrawGiftLogList({ eventId: this.activityId }).then((res) => {
        this.allGiftLogList = res;
      });
    },
    // 格式化奖品列表，计算每个奖品的位置
    formatPrizeList(list) {
      // 记录每个奖的位置
      const angleList = [];
      const l = list.length;
      // 计算单个奖项所占的角度
      const average = CIRCLE_ANGLE / l;
      const half = average / 2;
      // 循环计算给每个奖项添加style属性
      list.forEach((item, i) => {
        // 每个奖项旋转的位置为 当前 i * 平均值 + 平均值 / 2
        const angle = -(i * average + half);
        // 增加 style
        item.style = `-webkit-transform: rotate(${angle}deg);
                      transform: rotate(${angle}deg);`;
        // 记录每个奖项的角度范围
        angleList.push(i * average + half);
      });
      this.angleList = angleList;
      return list;
    },
    beginRotate() {
      if (this.prePrizeList.length == 0) {
        this.$toast("未获取到活动奖项，无法抽奖");
        return;
      }
      if (this.isNeedMember && !this.isMember) {
        this.$toast("您还不是本店微会员，请注册后参与活动");
        return;
      }
      // 添加次数校验
      if (this.drawCount === 0) {
        if (
          this.drawTimeInfo &&
          this.drawTimeInfo.UseIntegral &&
          (this.pointDrawCount == null || this.pointDrawCount > 0) &&
          this.MemberAccountId
        ) {
          Dialog.confirm({
            title: "提示",
            message:
              "您已没有抽奖机会，可消耗" +
              this.drawTimeInfo.UseIntegral +
              "积分兑换一次抽奖机会，是否兑换？",
            cancelButtonText: "不用了",
            confirmButtonText: "确认兑换",
          })
            .then(() => {
              getDrawTimesByPoint({
                EventId: this.activityId,
                MemberId: this.MemberAccountId,
              }).then((res) => {
                this.$toast("兑换成功！", "middle");

                this.drawCount = res.Item1;
                this.shareDrawCount = res.Item2; //当日剩余分享获取抽奖机会次数 null则不限制
                this.pointDrawCount = res.Item3; //当日剩余积分兑换抽奖机会次数 null则不限制
              });
            })
            .catch(() => {
              // on cancel
            });
        } else if (
          this.isEnableShare &&
          this.drawTimeInfo &&
          this.drawTimeInfo.ShareGiftDrawNum &&
          (this.shareDrawCount == null || this.shareDrawCount > 0)
        ) {
          this.$toast("您已没有抽奖机会，分享可获得抽奖机会哦！");
        } else {
          this.$toast("您已没有抽奖机会了哦！");
        }

        return;
      }
      // 开始抽奖
      // 这里这里向服务端发起请求，得到要获得的奖
      // 可以返回下标，也可以返回奖品 id，通过查询 奖品列表，最终得到下标
      // 随机获取下标
      if (this.isSubmiting) {
        this.$toast("正在请求中，请稍后");

        return;
      }
      this.isSubmiting = true;

      submitDraw({ EventId: this.activityId, EventClientId: 0 })
        .then((res) => {
          this.isSubmiting = false;

          const findGiftIndex = this.prePrizeList.findIndex(
            (item) => item.Id == res.Id
          );
          this.index = findGiftIndex;
          // 减少剩余抽奖次数
          this.drawCount--;

          // 开始旋转
          this.rotating();
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    },
    getShareDrawTimes() {
      getDrawTimesByShare({
        EventId: this.activityId,
      }).then((res) => {
        this.drawCount = res.Item1;
        this.shareDrawCount = res.Item2; //当日剩余分享获取抽奖机会次数 null则不限制
        this.pointDrawCount = res.Item3; //当日剩余积分兑换抽奖机会次数 null则不限制
      });
    },
    random(max, min = 0) {
      return parseInt(Math.random() * (max - min + 1) + min);
    },
    rotating() {
      const { isRotating, angleList, config, rotateAngle, index } = this;
      if (isRotating) return;
      this.isRotating = true;

      // 计算角度
      const angle =
        // 初始角度
        rotateAngle +
        // 多旋转的圈数
        config.circle * CIRCLE_ANGLE +
        // 奖项的角度
        angleList[index] -
        (rotateAngle % CIRCLE_ANGLE);

      this.rotateAngle = angle;
      // 旋转结束后，允许再次触发
      setTimeout(() => {
        this.rotateOver();
      }, config.duration + 1000);
    },
    rotateOver() {
      this.isRotating = false;
      this.getPrize = this.prizeList[this.index];
      console.log(this.getPrize, this.index);
      this.showResultModal = true;
    },
    handleShowRule() {
      this.showRuleModal = true;
    },
    handleShowGift() {
      this.handleGetGiftLogList();
      this.showGiftModal = true;
    },
    handleShowUseCode(v) {
      // let id = v.TicketCode;
      // this.$http(`discountticket/qrcode?code=${id}`).then(res => {
      // this.qrCode = 'data:image/png;base64,' + res.CodeDataSrc
      if (v.ProductType == "商品") {
        this.qrCodeList = [v.OrderId];
        this.showQr = true;
      } else {
        this.$router.push({
          name: "MyCouponList",
        });
      }

      // })
    },
    handleHideModal() {
      this.showRuleModal = false;
      this.showGiftModal = false;
      this.showResultModal = false;
    },
    handleHideCodeModal() {
      this.showQr = false;
    },
  },
};
</script>
<style scoped lang="scss">
.lucky_draw_con {
  min-height: 100vh;
}
.wheel_blue_con {
  padding: 32% 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // background: #f2f2eb;
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  .wheel_bg_con {
    width: 662px;
    height: 662px;
    position: relative;
    .start_draw_btn {
      width: 148px;
      height: 166px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -73px;
      margin-top: -100px;
      z-index: 2;
    }
  }
  .wheel-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    // background: url("../assets/img/draw_wheel.png") no-repeat center top;
    // background-size: 100%;
    // color: #fff;
    .prize-list {
      width: 100%;
      height: 100%;

      position: relative;

      .prize-item {
        position: absolute;
        width: 195px;
        height: 50%;
        padding-top: 85px;
        box-sizing: border-box;
        top: 0;
        left: 50%;
        margin-left: -97.5px;
        transform-origin: 50% 100%;
        text-align: center;
        color: #333;
      }
    }
  }
  .lucky_draw_times {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    padding: 15px 30px;
    border-radius: 40px;
    margin: 20px 0;
  }
  .draw_btn_con {
    display: flex;
    margin: 20px 0;
  }
}
.btn_item {
  width: 248px;
  height: 88px;
}
.bg_cover_con {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.overlay_con {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .close_btn_con {
    position: absolute;
    bottom: 12%;
    left: 50%;
    transform: translateX(-50%);
  }
}
.rule_overlay_con {
  width: 95vw;
  .rule_info_con {
    width: 80%;
    height: 800px;
    position: relative;
    .rule_induction_con {
      position: absolute;
      top: 35%;
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      color: #000;
      ::v-deep img {
        width: 100%;
        vertical-align: middle;
      }
      .ql-container {
        height: 400px;
      }
    }
  }
}
.result_overlay_con {
  .result_info_con {
    width: 80%;
    height: 800px;
    position: relative;
    .result_induction_con {
      width: 100%;
      position: absolute;
      top: 40%;
      text-align: center;
      padding: 30px;
      box-sizing: border-box;
      color: #000;
      // overflow: auto;
    }
  }
}
.gift_popup_con {
  background: none !important;
  .close_btn_con {
    margin: 30px auto 0;
  }
}
.gift_overlay_con {
  width: 95vw;
  .gift_info_con {
    width: 90%;
    height: 70%;
    position: relative;
    .gift_list_con {
      position: absolute;
      top: 32%;

      width: 100%;
      box-sizing: border-box;
      padding: 30px;
      box-sizing: border-box;
      color: #000;

      .gift_item_title {
        border-bottom: 1px solid #dedede;
        padding-bottom: 25px;
        font-size: 28px;
      }
      .gift_all_list {
        height: 450px;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
      }
      .gift_btn {
        width: 100px;
        height: 48px;
        background: linear-gradient(136deg, #e6c590 0%, #cba366 100%);
        border-radius: 8px;
        color: #fff;
        text-align: center;
        line-height: 48px;
        font-size: 22px;
      }
    }
  }
}
</style>
